import { init } from './ConfigHelper';

const { LOGIN_URL, RETURN_URL, COMPLETION_URL } = init(null);

export const statusUCMap = {
  // 未登录
  'UNAUTHENTICATED': `${LOGIN_URL}?returnUrl=${RETURN_URL}`,
  // 要激活
  'USER_NOT_ACTIVE': `${COMPLETION_URL}?returnUrl=${RETURN_URL}`
};

console.log('[uc.js]', statusUCMap);

const ERR_CODE_AUTH = 402;

export function getUCRedirect(response) {
  if (response.status !== ERR_CODE_AUTH) return;

  let errBody = response.error || JSON.parse(response.body);
  if (!errBody) {
    try {
      errBody = JSON.parse(response.body).error;
    } catch (ex) {} // eslint-disable-line no-empty
  }
  if (!errBody) return;
  if (errBody.error) {
    errBody = errBody.error;
  }
  const { code, status } = errBody;
  // console.log(response, errBody, code, status, ERR_CODE_AUTH)
  if (code !== ERR_CODE_AUTH) return;

  return statusUCMap.hasOwnProperty(status) // eslint-disable-line
    ? statusUCMap[status]
    : null;
}

export function redirectToUC(path = statusUCMap.UNAUTHENTICATED) {
  window.open(path, '_top');
}



// WEBPACK FOOTER //
// ./src/common/uc.js